import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStatus } from "../../hooks/useAuthStatus";
import Spinner from "../spinner";

const PublicOnlyGuard: React.FC<PropsWithChildren> = ({ children }) => {
    const { isLoggedIn, loading } = useAuthStatus();

    if (loading) {
        return <Spinner />;
    }

    if (isLoggedIn) {
        return <Navigate to="/courses" replace />;
    }

    return <>{children}</>;
};

export default PublicOnlyGuard;
